module.exports = __webpack_public_path__ + "img/center04.b6a39896.png";